import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function LayoutTemplate({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <LayoutTemplate.Outline {...props} />
  ) : (
    <LayoutTemplate.Solid {...props} />
  );
}

LayoutTemplate.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
        <line
          x1="3"
          y1="9"
          x2="21"
          y2="9"
          stroke="currentColor"
          strokeWidth="1.5"
          className="icon-outline"
        />
        <line
          x1="9"
          y1="9"
          x2="9"
          y2="21"
          stroke="currentColor"
          strokeWidth="1.5"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

LayoutTemplate.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <rect
          x="3"
          y="3"
          width="18"
          height="6"
          rx="2"
          fill="currentColor"
          className="icon-secondary"
        />
        <rect
          x="3"
          y="9"
          width="6"
          height="12"
          fill="currentColor"
          className="icon-primary"
        />
        <rect
          x="9"
          y="9"
          width="12"
          height="12"
          rx="0"
          fill="currentColor"
          className="icon-secondary"
        />
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
